import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const IssuesApi = createApi({
  reducerPath: "IssuesApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["ISSUESAPI"],
  endpoints: (build) => ({
    getIssues: build.query({
      query: ({ page, searchTerm, status }) => ({
        url: `/issues?page=${page}&search=${searchTerm}${status ? `&status=${status}` : ""}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["ISSUESAPI"],
    }),

    getIssuesById: build.query({
      query: ({ id }) => ({
        url: `/issues/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["ISSUESAPI"],
    }),

    editIssues: build.mutation({
      query: ({ id, data }) => ({
        url: `/issues/${id}`,
        method: "PUT",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["ISSUESAPI"],
    }),

    addIssues: build.mutation({
      query: ({ data }) => ({
        url: `/issues`,
        method: "POST",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["ISSUESAPI"],
    }),

    deleteIssues: build.mutation({
      query: ({ id }) => ({
        url: `/issues/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["ISSUESAPI"],
    }),
  }),
});

export const {
  useGetIssuesQuery,
  useGetIssuesByIdQuery,
  useEditIssuesMutation,
  useAddIssuesMutation,
  useDeleteIssuesMutation,
} = IssuesApi;
